import React from 'react';
import '../css/know-your-agency.css';

const TermsOfService = () => (
  <div className="know-your-agency-about">
    <h2>Terms of Use</h2>
    <p>Last updated March 22, 2021</p>
    <h3>AGREEMENT TO TERMS</h3>
    <p>These Terms of Use constitute a legally binding agreement made between you,
      whether personally or on behalf of an entity ("you") and Know Your Agency
      ("we," "us" or "our"), concerning your access to and use of the http://know-your-agency.com
      website as well as any other media form, media channel, mobile website or mobile
      application related, linked, or otherwise connected thereto (collectively, the "Site").
      You agree that by accessing the Site, you have read, understood, and agreed to be bound by
      all of these Terms of Use. IF YOU DO NOT AGREE WITH ALL OF THESE TERMS OF USE, THEN YOU
      ARE EXPRESSLY PROHIBITED FROM USING THE SITE AND YOU MUST DISCONTINUE USE IMMEDIATELY.
    </p>
    <p>
      Supplemental terms and conditions or documents that may be posted on the Site
      from time to time are hereby expressly incorporated herein by reference. We
      reserve the right, in our sole discretion, to make changes or modifications to
      these Terms of Use at any time and for any reason. We will alert you about any
      changes by updating the "Last updated" date of these Terms of Use, and you waive
      any right to receive specific notice of each such change. It is your responsibility
      to periodically review these Terms of Use to stay informed of updates. You will be
      subject to, and will be deemed to have been made aware of and to have accepted,
      the changes in any revised Terms of Use by your continued use of the Site after the
      date such revised Terms of Use are posted.
    </p>
    <p>
      The information provided on the Site is not intended for distribution to or
      use by any person or entity in any jurisdiction or country where such distribution
      or use would be contrary to law or regulation or which would subject us to any
      registration requirement within such jurisdiction or country. Accordingly, those
      persons who choose to access the Site from other locations do so on their own
      initiative and are solely responsible for compliance with local laws, if and to
      the extent local laws are applicable.
    </p>
    <p>
      The Site is intended for users who are at least 18 years old. Persons
      under the age of 18 are not permitted to use or register for the Site.
    </p>
    <h3>
      INTELLECTUAL PROPERTY RIGHTS
    </h3>
    <p>
      Unless otherwise indicated, the Site is our proprietary property and all
      source code, databases, functionality, software, website designs, audio,
      video, text, photographs, and graphics on the Site (collectively, the "Content")
      and the trademarks, service marks, and logos contained therein (the "Marks")
      are owned or controlled by us or licensed to us, and are protected by copyright
      and trademark laws and various other intellectual property rights and unfair
      competition laws of the United States, foreign jurisdictions, and international
      conventions. The Content and the Marks are provided on the Site.
    </p>
  </div>
)

export default TermsOfService;
